<div class="fee border bg-white rounded p-3 pl-4 position-relative">
  <form [formGroup]="form">
    <div class="fee_row main_row">
      <div class="col-50">
        <div class="fee_row">
          <div class="col-50 field-wrapper-mr">
            <mat-form-field2>
              <input matInput [placeholder]="amountPlaceholder" formControlName="amount" type="number" required />
              <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')">
                <ng-container i18n>Amount is required</ng-container>
              </mat-error>
              <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('min')">
                <ng-container i18n>Amount must be at least 1</ng-container>
              </mat-error>
              <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('max')">
                <ng-container i18n>Amount must be at most 100</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-50 field-wrapper-ml field-wrapper-mr">
            <mat-form-field2>
              <mat-select placeholder="Type" i18n-placeholder formControlName="type" required>
                <mat-option value="pct" i18n>Percent</mat-option>
                <mat-option value="flat" i18n>Flat</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('type').touched && form.get('type').hasError('required')">
                <ng-container i18n>Type is required</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
        </div>
        <div class="fee_row">
          <div class="col-100 field-wrapper-mr">
            <mat-form-field2>
              <mat-select
                matTooltip="Select the modality. This determines how the security deposit is applied to the booking"
                matTooltipPosition="above"
                i18n-matTooltip
                placeholder="Modality"
                i18n-placeholder
                formControlName="modality"
                required
              >
                <mat-option value="ps" i18n>Per Stay</mat-option>
                <mat-option value="pn" i18n>Per Night</mat-option>
                <mat-option value="pp" i18n>Per Person</mat-option>
                <mat-option value="pppn" i18n>Per Person/Per Night (PP/PN)</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('modality').touched && form.get('modality').hasError('required')">
                <ng-container i18n>Modality is required</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center gap-3 mb-3">
      <app-form-switch formControlName="status" [inline]="true">
        <ng-container *ngIf="form.get('status')" i18n>Active</ng-container>
        <ng-container *ngIf="!form.get('status')" i18n>Inactive</ng-container>
      </app-form-switch>
      <div class="flex-fill"></div>
    </div>
  </form>
</div>
